var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 5, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入FTDD单号查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.billNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "billNo", $$v)
                                      },
                                      expression: "queryParam.billNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "审核状态",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "全部",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.queryParam.auditStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.auditStatus",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "0" } },
                                        [_vm._v("未审核")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("已审核")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "9" } },
                                        [_vm._v("审核中")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 7, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "创建时间",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "show-time": "",
                                      format: "YYYY-MM-DD HH:mm:ss",
                                    },
                                    on: { change: _vm.onTimeChange },
                                    model: {
                                      value: _vm.queryTimeRange,
                                      callback: function ($$v) {
                                        _vm.queryTimeRange = $$v
                                      },
                                      expression: "queryTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 4, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "auditStatus",
                        fn: function (text) {
                          return [
                            text === "0"
                              ? _c("a-tag", { attrs: { color: "red" } }, [
                                  _vm._v("未审核"),
                                ])
                              : text === "9"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("审核中"),
                                ])
                              : _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已审核"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "claimStatus",
                        fn: function (text) {
                          return [
                            text === "0"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("待认领"),
                                ])
                              : _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("正常"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "status",
                        fn: function (text) {
                          return [
                            text === "0"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("待校正"),
                                ])
                              : _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已生成订单"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goDetail(record)
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              ),
                              record.auditStatus === "0" && _vm.canAudit
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        title: "确定审核通过该发图单吗?",
                                      },
                                      on: {
                                        confirm: () => _vm.handleAudit(record),
                                      },
                                    },
                                    [_c("a", [_vm._v("审核")])]
                                  )
                                : _vm._e(),
                              record.auditStatus === "0" && _vm.canSubmitFlow
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        title: "确定提交该发图单至审批流程吗?",
                                      },
                                      on: {
                                        confirm: () =>
                                          _vm.handleSubmitFlow(record),
                                      },
                                    },
                                    [_c("a", [_vm._v("提交流程")])]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }